module.exports = __webpack_public_path__ + "img/bp_lp_watage_bg.4d5e9086.png";